import { render, staticRenderFns } from "./IconSvgDoc.vue?vue&type=template&id=1e1e0be2&scoped=true&"
import script from "./IconSvgDoc.vue?vue&type=script&lang=js&"
export * from "./IconSvgDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1e0be2",
  null
  
)

export default component.exports